/**
 * src/components/agent/DrivingModeToggle.jsx — Presentation-only toggle
 * (Phase 82-05). 56px touch target. Navy-on / glass-off.
 */

import { Car } from 'lucide-react';

const btnStyle = (on) => ({
  minWidth: 56,
  minHeight: 56,
  padding: '0 14px',
  borderRadius: 14,
  background: on ? 'var(--navy-surface)' : 'var(--glass)',
  color: on ? 'var(--on-navy)' : 'var(--t1)',
  border: on ? '1px solid var(--navy)' : '1px solid var(--bdr)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: 0.2,
});

export default function DrivingModeToggle({ on = false, onToggle, label = 'Driving' }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      style={btnStyle(on)}
      aria-pressed={on}
      aria-label={`Driving mode ${on ? 'on' : 'off'}`}
      data-testid="driving-mode-toggle"
      data-on={on ? 'true' : 'false'}
    >
      <Car size={18} strokeWidth={2} />
      <span>{label}</span>
    </button>
  );
}
